import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const segmentedControlFn = /* @__PURE__ */ createRecipe('SegmentedControl', {
  "isInverted": true,
  "isRounded": false,
  "size": "md",
  "orientation": "horizontal"
}, [
  {
    "isRounded": true,
    "orientation": "vertical",
    "size": "sm",
    "css": {
      "&[data-part=\"root\"]": {
        "borderRadius": "2xl"
      }
    }
  },
  {
    "isRounded": true,
    "orientation": "vertical",
    "size": "md",
    "css": {
      "&[data-part=\"root\"]": {
        "borderRadius": "3xl"
      }
    }
  },
  {
    "isRounded": true,
    "orientation": "vertical",
    "size": "lg",
    "css": {
      "&[data-part=\"root\"]": {
        "borderRadius": "3xl"
      }
    }
  }
])

const segmentedControlVariantMap = {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "orientation": [
    "horizontal",
    "vertical"
  ],
  "isRounded": [
    "true",
    "false"
  ],
  "isInverted": [
    "true",
    "false"
  ],
  "isFull": [
    "true"
  ]
}

const segmentedControlVariantKeys = Object.keys(segmentedControlVariantMap)

export const segmentedControl = /* @__PURE__ */ Object.assign(memo(segmentedControlFn.recipeFn), {
  __recipe__: true,
  __name__: 'segmentedControl',
  __getCompoundVariantCss__: segmentedControlFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: segmentedControlVariantKeys,
  variantMap: segmentedControlVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, segmentedControlVariantKeys)
  },
  getVariantProps: segmentedControlFn.getVariantProps,
})